/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Label, Table, Button, Col, Row, Input } from 'reactstrap'
import InputNumber from 'rc-input-number';

import {AppContext} from '../AppContext';

class SimilaritySearch  extends React.Component
{
  constructor()
  {
    super();

    this.state =
    {
      topK: 5,
      similarImages: [],
      useVectorIndex: true,
      accuracy: 95
    }

    this.findSimilarImages = this.findSimilarImages.bind(this);
    this.setTopK = this.setTopK.bind(this);
    this.toggleUseIndex = this.toggleUseIndex.bind(this);
    this.setAccuracy = this.setAccuracy.bind(this);
  }

  async findSimilarImages()
  {
    let bodyData = {};

    let selectedKeywordsAndValues = [];
    if (undefined !== this.props.filterData)
    {
      if (undefined !== this.props.filterData[0].queryKeyword)
      {
        for (let y = 0; y < this.props.filterData.length; y++)
        {
          let selectedKeywordAndValue = {keywordId: null, valueId: null, operator: this.props.filterData[y].operator.value};
          if (null !== this.props.filterData[y].queryKeyword)
          {
            selectedKeywordAndValue.keywordId = this.props.filterData[y].queryKeyword.keywordId;
            if (null !== this.props.filterData[y].queryValue) selectedKeywordAndValue.valueId = this.props.filterData[y].queryValue.valueId;
            selectedKeywordsAndValues[selectedKeywordsAndValues.length] = selectedKeywordAndValue;
          } 
        }
      }
    }

    let objectTypeIds = [];

    for (let x = 0; x < this.props.objectTypePickerData.length; x++)
    {
      if (this.props.objectTypePickerData[x].selected && x)   // Including test for x filters out the first entry which corresponds to 'all' data types.
        objectTypeIds[objectTypeIds.length] = this.props.objectTypePickerData[x].objectTypeId;
    }

    bodyData.objectId = this.props.objectId;
    bodyData.objectTypeIds = objectTypeIds;
    bodyData.viewType = this.props.viewType;
    bodyData.topK = this.state.topK;
    bodyData.useVectorIndex = this.state.useVectorIndex ? 'Y' : 'N';
    bodyData.selectedKeywordsAndValues = selectedKeywordsAndValues;
    bodyData.accuracy = this.state.accuracy;

    if (undefined !== this.props.matchAnyOrAll) bodyData.matchAnyOrAll = this.props.matchAnyOrAll;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'findSimilarImages', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Unable to find similar images');
    this.setState({similarImages: result.jsonData});
  }

  render()
  {
    return(
      <Row>
        <Col sm='2'>
          <Row style={{paddingTop: '10px'}}><Col>Find images similar to this image:</Col></Row>
          <Row style={{paddingTop: "10Px"}}>
            <Col >
              <Label title="The number of hits to send upstream to the LLLM - from 5 to 15">RAG Response Limit</Label>
            </Col>
            <Col>
              <InputNumber style={{ width: 100 }} id='mmTopK' min={1} max={15}
                onChange={this.setTopK} value={this.state.topK} />
            </Col>
          </Row>
          <Row style={{paddingTop: '10px'}}>
            <Col><Label>Use Vector Index</Label></Col>
            <Col>
              <Input type="checkbox" id="useVectorIndex" name="useVectorIndex" onChange={this.toggleUseIndex}
              checked={(this.state.useVectorIndex ? 'checked' : '')} style={{marginLeft: 0, marginTop: '0.7rem'}}
              title="Check this box to use the vector index (if any) for this search"/>
            </Col>
          </Row>
          <Row style={{paddingTop: "10Px"}}>
            <Col >
              <Label title="The accuracy setting for a vector index search">Indexed Search Accuracy</Label>
            </Col>
            <Col>
              <InputNumber style={{ width: 100 }} id='accuracy' min={1} max={100}
                onChange={this.setAccuracy} value={this.state.accuracy} />
            </Col>
          </Row>
          <Row style={{paddingTop: '10px'}}><Col><Button onClick={this.findSimilarImages} color="primary">Search</Button></Col></Row>
        </Col>
        <Col sm='4'>
          <img style={{maxWidth: '100%', paddingTop: '10px', paddingBottom: '10px', marginLeft: 'auto', marginRight: 'auto', display: 'block'}} 
            src={this.props.source}  alt="Object view" 
          />
        </Col>
        <Col sm='6'>
          <Table>
            <tbody>
              { this.state.similarImages.map((similarImage, index) =>
              (
                <div>
                  <tr><td><Row><Col>{similarImage.objectName}</Col><Col>{similarImage.score}</Col></Row></td></tr>
                  <tr><td><img style={{maxWidth: '100%', paddingTop: '10px', paddingBottom: '10px', marginLeft: 'auto', marginRight: 'auto', display: 'block'}} 
                    src={similarImage.weblink}  alt="similar object" />
                  </td></tr>
                </div>
              ))}
            </tbody>
          </Table>
        </Col>        
      </Row>
    );
  }

  setAccuracy(valueAsNumber)
  {
    this.setState({accuracy: valueAsNumber});
  }

  setTopK(valueAsNumber, valueAsString, input)
  {
    this.setState({topK: valueAsNumber});
  }

  toggleUseIndex()
  {
    this.setState({useVectorIndex: !this.state.useVectorIndex})
  }
  
}

SimilaritySearch.contextType = AppContext;

export default SimilaritySearch